import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../shadcn/components/ui/table";

import {
  ColumnDef,
  ColumnFiltersState,
  SortingState,
  VisibilityState,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

import { useSelector } from "react-redux";
import { getAllAuctionEvents } from "services";
import { Button } from "../../../../../shadcn/components/ui/button";
import { DateTime } from "luxon";
import ArrowInclinedSvg from "../../../../../icons/ArrowInclinedSvg";
import PropertyDetailsModel from "../../allEvents/PropertyDetailsModel";
import { useRouter } from "next/router";
export type tableData = {
  [x: string]: any;
  id: string;
};

export default function UpcomingEventTable() {
  const router = useRouter();
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const portalAccessType = useSelector((state: any) => {
    return state.bidderAuth.portalAccessType;
  });
  const onlySwissEventUser = portalAccessType === "swiss";
  const [events, setEvents] = useState([]);
  const init = async () => {
    if (onlySwissEventUser !== true) {
      const result: any = await getAllAuctionEvents(
        ["accepted"],
        DateTime.fromJSDate(new Date())
          .setZone("Asia/Kolkata")
          .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
          .toUTC()
          .toISO() || null,
        null,
        null, // limitBy
        8, // page
        null // search
      );
      setEvents(result?.data || []);
    }
  };

  useEffect(() => {
    if (user) {
      init();
    }
  }, [portalAccessType]);

  const [open, setOpen] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});

  const viewDetailsClickHandler = (propertyData: any) => {
    setSelected({
      ...propertyData.property,
      images: [
        {
          path_to_file:
            propertyData?.property_dump?.images?.length > 0
              ? propertyData?.property_dump?.images?.[0]?.path_to_file
              : propertyData?.property_dump?.sub_asset_type_images?.length > 0
              ? propertyData?.property_dump?.sub_asset_type_images?.[0]
                  ?.path_to_file
              : process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
              ? `${".com/"}/27f785cc-24cb-4531-9b91-4a6c58bfaf37`
              : `${".com/"}/771263b2-a630-46f2-ae99-24cece88c4be`,
          uuid:
            propertyData?.property_dump?.images?.length > 0
              ? propertyData?.property_dump?.images?.[0]?.uuid
              : propertyData?.property_dump?.sub_asset_type_images?.length > 0
              ? propertyData?.property_dump?.sub_asset_type_images?.[0]?.uuid
              : process.env.NEXT_PUBLIC_IMAGIX_URL?.includes("staging")
              ? "27f785cc-24cb-4531-9b91-4a6c58bfaf37"
              : "771263b2-a630-46f2-ae99-24cece88c4be",
        },
      ],
      data: propertyData,
      listing_id: propertyData?.listing_id,
      property_date_type: propertyData?.property?.property_date_type,
      bank: propertyData?.bank,
      reserve_price: propertyData?.reserve_price,
      asset: propertyData?.property_dump?.asset,
      sub_asset_type: propertyData?.property_dump?.sub_asset_type,
      city: propertyData?.property_dump?.city,
      state: propertyData?.property_dump?.state,
      start_date_time: propertyData?.start_date_time,
    });
    setOpen(true);
  };

  const columns: ColumnDef<tableData>[] = [
    // {
    //   accessorKey: "event_name",
    //   header: () => (
    //     <div className="text-[10px] sm:text-xs min-w-14">Event Name</div>
    //   ),
    //   cell: ({ row }) => {
    //     return (
    //       <div className="text-[10px] sm:text-xs min-w-24">
    //         {(row.getValue("event_name") as string)?.length > 12
    //           ? `${(row.getValue("event_name") as string).slice(0, 12)}...`
    //           : row.getValue("event_name") || "N/A"}
    //       </div>
    //     );
    //   },
    // },
    {
      accessorKey: "listing_id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="text-[10px] sm:text-xs px-0 min-w-14 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Event ID
        </Button>
      ),
      cell: ({ row }) => (
        <div className="min-w-24 text-[10px] sm:text-xs ">
          {row.getValue("listing_id")}
        </div>
      ),
    },

    {
      accessorKey: "start_date_time",
      header: "Start  ",
      cell: ({ row }) => {
        return (
          <div className="capitalize text-[10px] sm:text-xs break-keep min-w-[200px]">
            {row.getValue<string>("start_date_time") ? (
              <div className="flex items-center divide-x divide-gray-400">
                <div className="pr-3 break-keep">
                  {DateTime.fromISO(row.getValue<string>("start_date_time"))
                    .setZone("Asia/Kolkata")
                    .toFormat("dd MMM yyyy")}
                </div>
                <div className="px-3 break-keep">
                  {`${DateTime.fromISO(row.getValue<string>("start_date_time"))
                    .setZone("Asia/Kolkata")
                    .toFormat("hh:mm a")} (IST)`}
                </div>
              </div>
            ) : null}
          </div>
        );
      },
    },
    {
      accessorKey: "end_date_time",
      header: "End",
      cell: ({ row }) => (
        <div className="capitalize text-[10px] sm:text-xs break-keep min-w-[200px]">
          {row.getValue<string>("end_date_time") ? (
            <div className="flex items-center divide-x divide-gray-400">
              <div className="pr-3 break-keep">
                {DateTime.fromISO(row.getValue<string>("end_date_time"))
                  .setZone("Asia/Kolkata")
                  .toFormat("dd MMM yyyy")}
              </div>
              <div className="px-3 break-keep">
                {`${DateTime.fromISO(row.getValue<string>("end_date_time"))
                  .setZone("Asia/Kolkata")
                  .toFormat("hh:mm a")} (IST)`}
              </div>
            </div>
          ) : null}
        </div>
      ),
    },
    {
      id: "actions",
      header: () => <div className="text-center">Actions</div>,
      cell: ({ row }) => {
        return (
          <Button
            className="h-7 px-0 text-xs bg-transparent hover:bg-transparent"
            onClick={() => viewDetailsClickHandler(row.original)}
          >
            <ArrowInclinedSvg fill="#262626" width={24} height={24} />
          </Button>
        );
      },
    },
  ];
  const divRef = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    const updateWidth = () => {
      if (divRef.current) {
        setWidth(divRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, [window?.innerWidth, width]);

  return (
    <div
      ref={divRef}
      className={`pt-3 bg-white !important border border-brand-borderGreyTwo`}
    >
      <div className="flex items-center justify-between text-sm pl-4 pb-2 lg:pb-4">
        <h3 className="text-sm font-semibold">Upcoming Event</h3>
        <div className="flex gap-1 lg:gap-4 items-center">
          {/* <div className="pr-2 lg:pr-4"> Location</div> */}
          {events?.length > 5 && (
            <Button
              className="h-8 bg-white text-sm hover:bg-white text-brand-textBlack font-semibold underline"
              onClick={() => router.push(`/all-events`)}
            >
              View all
            </Button>
          )}
        </div>
      </div>
      <div className="mx-auto !important" style={{ width: `${width - 30}px` }}>
        <CustomUpcomingTable data={events?.slice(0, 5)} columns={columns} />
      </div>
      <PropertyDetailsModel open={open} setOpen={setOpen} selected={selected} />
    </div>
  );
}

type DataTableProps<T> = {
  data: T[];
  columns: ColumnDef<T>[];
  actions?: (row: T) => React.ReactNode;
  searchComponent?: React.ReactNode;
  filterComponent?: React.ReactNode;
};

function CustomUpcomingTable<T>({ data, columns, actions }: DataTableProps<T>) {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });
  return (
    <Table>
      <TableHeader className="border text-[10px] sm:text-xs bg-[#F8F8F8">
        {table.getHeaderGroups().map((group) => (
          <TableRow key={group.id}>
            {group.headers.map((header) => (
              <TableHead key={header.id}>
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
              </TableHead>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody className="text-xs font-normal">
        {table.getRowModel().rows.length ? (
          table.getRowModel().rows.map((row) => (
            <TableRow key={row.id} className="py-0">
              {row.getVisibleCells().map((cell) => (
                <TableCell className="px-2 py-3" key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
              {actions && <TableCell>{actions(row.original)}</TableCell>}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={columns.length + (actions ? 1 : 0)}
              className="h-44 text-center"
            >
              No Auction Event found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
